module.exports = __webpack_public_path__ + "img/agla.d0551d2d.svg";